import { render, staticRenderFns } from "./property-results-cards.vue?vue&type=template&id=405d9ec7&scoped=true&"
import script from "./property-results-cards.vue?vue&type=script&lang=ts&"
export * from "./property-results-cards.vue?vue&type=script&lang=ts&"
import style0 from "./property-results-cards.vue?vue&type=style&index=0&id=405d9ec7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405d9ec7",
  null
  
)

export default component.exports